import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
@Injectable({ providedIn: 'root' })
export class ConvenantService extends BaseService {
  getCompanyType() {
    const url = `${environment.convenantApi}/Convenant/ListCompanyType`;
    return this.http.get(url);
  }
  getFilterBase() {
    const url = `${environment.convenantApi}/Convenant/GetFilterBase`;
    return this.http.get(url);
  }
  getListCities() {
    const url = `${environment.convenantApi}/Convenant/ListCities`;
    return this.http.get(url);
  }
  getCheckConvenantCode() {
    const url = `${environment.convenantApi}/Convenant/CheckConvenantCode`;
    return this.http.get(url);
  }
  getListCompanyType() {
    const url = `${environment.convenantApi}/Convenant/ListCompanyType`;
    return this.http.get(url);
  }
  getListMedicalExpertise() {
    const url = `${environment.convenantApi}/Convenant/ListMedicalExpertise`;
    return this.http.get(url);
  }
  getListNeighborhood() {
    const url = `${environment.convenantApi}/Convenant/ListNeighborhood`;
    return this.http.get(url);
  }
  getListPlans() {
    const url = `${environment.convenantApi}/Convenant/ListPlans`;
    return this.http.get(url);
  }
  getListProfessionalCouncils() {
    const url = `${environment.convenantApi}/Convenant/ListProfessionalCouncils`;
    return this.http.get(url);
  }
  getListStates() {
    const url = `${environment.convenantApi}/Convenant/ListStates`;
    return this.http.get(url);
  }
  getSearchConvenant(form: any) {
    const url = `${environment.convenantApi}/Convenant/SearchConvenant?` + this.paramsToQueryString(form);
    return this.http.get(url);
  }
  getSearchConvenantByDate() {
    const url = `${environment.convenantApi}/Convenant/SearchConvenantByDate`;
    return this.http.get(url);
  }
  getSearchConvenantDocument() {
    const url = `${environment.convenantApi}/Convenant/SearchConvenantDocument`;
    return this.http.get(url);
  }
  getSearchSimpleConvenant() {
    const url = `${environment.convenantApi}/Convenant/SearchSimpleConvenant`;
    return this.http.get(url);
  }
}
